import { Constructor } from '../mixins/constructor';

export interface AgencyBlocCustomFieldItem {
  Name: string;
  Value: string[];
}

/**
 * AgencyBloc Custom Field Mixin
 * This mixin is used to add custom field functionality to AgencyBloc entities
 */
export function AgencyBlocCustomField<T extends Constructor<{}>>(Base: T = class {} as any) {
  return class extends Base {
    public customFields: AgencyBlocCustomFieldItem[] = [];

    /**
     *
     * @param {string} name - The name of the custom field to get the value of
     * @returns {string | undefined}
     */
    public getCustomFieldValue(name: string): string | undefined {
      if (!Array.isArray(this.customFields)) return '';
      return this.customFields.find((field) => field.Name === name)?.Value[0] || '';
    }

    /**
     * Set the value of a custom field
     * @param {string} name - The name of the custom field to set the value of
     * @param {string} value - The value to set the custom field to
     */
    public setCustomFieldValue(name: string, value: string): void {
      const field = this.customFields.find((field) => field.Name === name);
      if (field) {
        field.Value[0] = value;
      } else {
        this.customFields.push({
          Name: name,
          Value: [value],
        });
      }
    }
  };
}
